import {
  DepositModalOveride,
  DepositModalQROveride,
} from "pages/DepositPage/DepositModal/DepositModal.style";
import { CropImageModalOveride } from "pages/ProfilePage/ProfileCard/ProfileCard.style";
import { createGlobalStyle } from "styled-components";

import { antDatePickerOveride, antSelectOveride } from "./overide";
import { cssReset } from "./reset";

export const GlobalStyle = createGlobalStyle`
    ${cssReset}
    ${antSelectOveride}
    ${antDatePickerOveride}
    ${DepositModalOveride}
    ${DepositModalQROveride}
    ${CropImageModalOveride}
`;
